import { isIOS, isMobile, isAndroid, browserName } from "react-device-detect";

// https://github.com/duskload/react-device-detect/blob/HEAD/docs/selectors.md

const getDeviceType = () => {
  return isMobile ? "mobile" : "desktop";
};

const getBrowserName = () => {
  return browserName;
};

export { isIOS, isAndroid, getDeviceType, getBrowserName };
